import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';
import Identity from './identity';
import { headers, logPrefix } from './constants';

import { GdprReport, isGdprReport } from './gdpr';

/**
 * Gets the logged-in user's GDPR report by ID
 *
 * @returns
 * A __Promise__ resolving to a GDPR report.
 *
 * <details>
 * <summary>
 * On success (resolves)
 * </summary>
 *
 * ```json
 * {
 *   "asOfDate": "2019-06-17 12:00:00",
 *   "data": "{\"gender\": null, \"picture\": null, \"birthDay\": null, \"contacts\": null, \"lastName\": \"example\", \"legacyId\": null, \"addresses\": null, \"birthYear\": null, \"firstName\": \"demo\", \"attributes\": null, \"birthMonth\": null, \"displayName\": \"demo@example.com\", \"secondLastName\": null}"
 *   "displayName": "demo@example.com",
 *   "email": null,
 *   "firstName": "demo",
 *   "lastName": "example",
 *   "secondLastName": null
 * }
 * ```
 *
 * </details>
 *
 */

export default async function getGdprReport(id: number): Promise<GdprReport | APIErrorResponse> {
  const isLoggedIn = await Identity.isLoggedIn();
  if (!isLoggedIn) {
    throw new Error(`${logPrefix} Missing or invalid jwt`);
  }

  return fetch(`${Identity.apiOrigin}/identity/public/v1/gdpr/${id}`, {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${Identity.userIdentity.accessToken}`,
      ...headers
    }
  })
    .then(JSONResponseHandler)
    .then(json => {
      if (isGdprReport(json)) {
        return json;
      } else {
        throw json;
      }
    });
}
